import { Component, effect, inject, model } from '@angular/core';

import { NgIcon, provideIcons } from '@ng-icons/core';
import { WarehouseFormComponent } from '../warehouse-form/warehouse-form.component';
import {
  lucidePenLine,
  lucideWarehouse,
  lucideArrowRightLeft,
  lucideTrash2,
} from '@ng-icons/lucide';

import { CrudService } from '../../core/services/crud.service';

@Component({
  selector: 'app-warehouse-list',
  imports: [NgIcon, WarehouseFormComponent],
  viewProviders: [
    provideIcons({
      lucideWarehouse,
      lucideArrowRightLeft,
      lucidePenLine,
      lucideTrash2,
    }),
  ],
  templateUrl: './warehouse-list.component.html',
  styles: ``,
})
export class WarehouseListComponent {
  private crudService = inject(CrudService);

  warehouses: Array<any> = [];
  existingWarehouse: any;

  showModal = model(false);

  constructor() {
    effect(() => {
      if (!this.showModal()) {
        this.getWarehouses();
      }
    });
  }

  openModal() {
    this.existingWarehouse = null;
    this.showModal.set(true);
  }

  getWarehouses() {
    this.crudService.getWarehouses().subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.warehouses = response.body;
        }
      },
    });
  }

  updateWarehouse(warehouse: any) {
    this.existingWarehouse = warehouse;
    this.showModal.set(true);
  }

  deleteWarehouse(warehouseId: string) {
    this.crudService.deleteWarehouse(warehouseId).subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.getWarehouses();
        }
      },
    });
  }
}
